export default __webpack_public_path__ + "static/25-cfb62381738d9de3707288783e66017c.jpg";